/**
 * Ajuda dos campos do tomador.
 *
 * Juntada em `../ajudaDosCampos.ts`, que explica a chave e o texto. Ver
 * docs/FRONTEND.md, secao 6.
 */
export const ajuda: Record<string, Record<string, string>> = {
  '/tomadores': {
    // Leiloeiro e tomador pessoa fisica (P-NCT-3).
    'Nome completo':
      'Nome completo da pessoa fisica. Na pessoa juridica o campo e a razao social.',
    'UF da junta comercial':
      'Estado da junta comercial em que o leiloeiro e matriculado. Leva o tomador pessoa fisica a ser leiloeiro; so vale para CPF.',
    'Matricula na junta comercial':
      'Numero da matricula do leiloeiro na junta comercial. Opcional: nao decide nada.',
    'Limite de credito aprovado (R$)':
      'Limite registrado no cadastro do tomador. Vazio significa que nao ha limite aprovado. So quem tem a permissao de alterar o credito do tomador muda o limite.',
    Situacao:
      'Ativo, inativo ou bloqueado. Bloqueado nao recebe operacao nova. So quem tem a permissao de alterar o credito do tomador bloqueia, desbloqueia, ativa ou inativa.',
    'Capital social (R$)': 'Capital declarado no contrato social do tomador, em reais.',
    Porte:
      'Enquadramento da empresa: MEI, microempresa, pequeno, medio ou grande porte.',
    'Natureza juridica': 'Forma juridica da empresa, como consta no cadastro do CNPJ.',
    'Data de abertura':
      'Data de abertura da empresa no CNPJ. Nao pode estar no futuro.',
    'Comercial responsavel':
      'Pessoa da empresa que cuida da conta. Texto livre: nao precisa ter acesso a plataforma.',
    Corretor:
      'Corretora que atende o tomador. A lista traz so corretores ativos; sem corretor, o tomador e atendido em operacao direta.',
    'Data de validade cadastral':
      'Data ate a qual o cadastro do tomador vale. E registrada a mao: a regra que calcula a validade pelo porte esta pendente.',
    'Comissao do tomador (%)':
      'Comissao diferenciada combinada para o tomador, entre 0 e 100. Vazio significa sem comissao diferenciada. A operacao ainda nao a aplica sozinha (regra pendente).',
    'Instrumento da nomeacao':
      'Como o corretor foi nomeado para o tomador: primeira emissao, CCG ou carta de nomeacao.',
    'Cadastro na Receita':
      'Situacao do CNPJ na Receita Federal: ativa, suspensa, inapta, baixada ou nula. A consulta do CNPJ (SeguraCoreData) preenche este campo, que nao e a Situacao do tomador na plataforma.',
    'Status de credito':
      'Aprovacao manual do tomador. So quem tem a permissao de alterar o credito do tomador muda. Ainda nao trava operacao nova (regra pendente).',
    'Ramo ou CNAE restrito':
      'Marca do ramo de atividade ou CNAE restrito. Vazio e nao informado. O efeito na subscricao esta pendente de regra.',
    'Digite o CNPJ da filial':
      'CNPJ do estabelecimento filial. Precisa ter a mesma raiz do CNPJ do tomador (os oito primeiros digitos) e ser diferente dele.',
    'Documento do Grupo economico':
      'CPF ou CNPJ de quem encabeca o grupo economico. O documento nao muda depois: outro documento e outro grupo.',
    '% Participacao':
      'Participacao do tomador no grupo, entre 0 e 100. A validacao a partir de 26% esta pendente de regra.',
    'Limite do grupo (R$)':
      'Limite do grupo economico, um so para todos os tomadores do grupo. E decisao de credito: so quem tem a permissao de alterar o limite do grupo o define. E registrado e nao bloqueia emissao (regra pendente).',
    'Premio fixo (R$)':
      'Premio fixo combinado com o tomador para a modalidade. Fica registrado; o calculo do premio ainda nao o aplica (regra pendente).',
    'Premio Minimo (R$)':
      'Premio minimo combinado com o tomador para a modalidade. Fica registrado; o calculo do premio ainda nao o aplica (regra pendente).',
    'Aprovado (R$)':
      'Limite aprovado para o grupo de modalidades. O disponivel e o aprovado menos o utilizado, sem ficar negativo.',
    'Utilizado (R$)':
      'Quanto do limite do grupo esta em uso. E registrado a mao: a metrica de consumo do limite esta pendente de regra.',
    'Taxa seguro publico (%)':
      'Taxa do grupo para segurado publico, em percentual com ate duas casas. O servidor guarda em pontos-base.',
    'Taxa seguro privado (%)':
      'Taxa do grupo para segurado privado, em percentual com ate duas casas. O servidor guarda em pontos-base.',
    'Limite Revisado (R$)':
      'Limite revisado na analise de credito do tomador. Registro da analise; nao muda o limite geral nem o dos grupos.',
    'Score Final':
      'Score do tomador no bureau, de 0 a 1000. Vazio e nao informado, que nao e o mesmo que zero.',
    'Classe de Risco Financeiro':
      'Classe de risco na escala de credito: AA, A, BB, B, CC, C, DD ou D.',
    'Porte de credito':
      'Porte na escala de credito (Small a Corporate+). E diferente do porte do cadastro (MEI a grande) e nao ha conversao.',
    CCF: 'Quantidade de cheques sem fundo. Zero registrado vale; vazio e nao informado.',
    Pontos:
      'Pontos de restritivos do tomador. Zero registrado vale; vazio e nao informado.',
    'Debitos Pefins (R$)': 'Valor de PEFIN do tomador, em reais.',
    // P-TOM-C1: tomador complementar.
    'Tipo de pessoa':
      'Pessoa juridica (CNPJ) ou fisica (CPF). A pessoa fisica so aparece quando a empresa tem o cadastro de tomador pessoa fisica habilitado.',
    'CPF/CNPJ':
      'CNPJ com catorze digitos ou CPF com onze, conferido pelo digito verificador. Com o CNPJ completo, a Receita Federal (SeguraCoreData) preenche os campos vazios; o que ja foi digitado so muda se voce confirmar.',
    'Atividade principal (CNAE)':
      'Subclasse da CNAE 2.3 do IBGE. Busque por codigo ou descricao e escolha: o codigo vai com sete digitos e a descricao vem da CNAE.',
    'Direito privado':
      'Significado a confirmar com a seguradora. Vazio e nao informado. Nao decide nada.',
    'Motivo padronizado da negativa':
      'Motivo de credito cadastrado em Configuracoes. Vale so com o status de credito Reprovado e exige a permissao de alterar o credito do tomador.',
    'Motivo da negativa':
      'Texto da negativa de credito. Escolher o motivo padronizado preenche o texto. Sai quando o status de credito deixa de ser Reprovado.',
    'Meio de pagamento':
      'Lista de meios de pagamento da empresa, cadastrada em Configuracoes. A conta guarda o nome do meio no momento da inclusao.',
    'Novo nome fantasia':
      'Nome fantasia a mais na lista do tomador. Marcado como principal, passa a ser o nome fantasia do cadastro.',
    'Novo telefone':
      'Telefone a mais na lista do tomador, com ao menos oito digitos. Marcado como principal, passa a ser o telefone do cadastro.',
    'Pais (sigla)':
      'Sigla de duas letras do pais do endereco no exterior, como PT. O endereco no exterior nao pode ser o principal.',
    'Nomear documento':
      'Nome com que o documento aparece em Documentos disponiveis. O arquivo e enviado junto e fica versionado; a exclusao apaga o arquivo e deixa o registro em Documentos excluidos.',
    // P-TOM-C2: reprocessamento.
    'Operacao avaliada pelo motor':
      'Operacao do tomador que o motor de credito avalia no reprocessamento. Vazio usa a operacao da ultima execucao do motor; sem nenhuma, o motor nao executa e o motivo fica registrado.',
    // P-TOM-C5: grupo economico como entidade e nomeacao do corretor.
    'Novo limite do grupo (R$)':
      'Limite do grupo economico, informado por quem tem a permissao de alterar o limite do grupo. Vale para todos os tomadores do grupo; vazio limpa. Nao bloqueia emissao nem consome nada: o teto do grupo esta pendente de regra.',
    'Limite do grupo na modalidade (R$)':
      'Limite do grupo economico no grupo de modalidades. Registrado com o historico e sem efeito na emissao (regra pendente).',
    'Grupo de modalidades':
      'Os grupos do limite do tomador: tradicional, estruturadas, judicial, recursal, financeira e fianca.',
    'Troca do corretor':
      'Como a empresa troca o corretor do tomador: por pedido de nomeacao, decidido pela seguradora, ou direto no cadastro. Os pedidos abertos continuam decidiveis depois da troca de modo.',
    'Corretora a nomear':
      'Corretora que passa a atender o tomador quando a seguradora aprovar o pedido. So corretores ativos.',
    'Tipo do pedido':
      'Pedido de nomeacao, como o da corretora, ou nomeacao pela seguradora. Os dois esperam a decisao da seguradora.',
    'Validade da nomeacao':
      'Data ate a qual a nomeacao vale. Vai para o cadastro na aprovacao. A validade vencida nao encerra a nomeacao: o efeito esta pendente de regra.',
    'Tipo de nomeacao':
      'Instrumento da nomeacao: primeira emissao, CCG ou carta de nomeacao.',
    'Observacao do pedido': 'Texto livre do pedido, com ate 2000 caracteres.',
    'Motivo da recusa':
      'Motivo padronizado da esteira Nomeacao, cadastrado em Configuracoes. Sem motivo, a justificativa escrita e obrigatoria.',
    Justificativa: 'Por que o pedido foi recusado, com ate 2000 caracteres.',
    'Observacao da decisao': 'Texto livre da decisao, com ate 2000 caracteres.',
    // P-TOM-C4: analises do proprio tomador.
    'Tipo da analise':
      'Assunto da analise do tomador: cadastro, credito, PEP, grupo economico ou revisao de limite. Aparecem os tipos ligados pela empresa e sem analise do mesmo tipo em andamento.',
    'Pedido de revisao de limite':
      'Pedido pendente que a analise acompanha. A decisao da analise e a do pedido: nao ha segundo pedido nem segunda decisao.',
    'Motivo da analise':
      'Por que a analise foi aberta, com ate 2000 caracteres. A corretora nao ve o motivo.',
    Anotacao:
      'Registro na linha do tempo da analise, com ate 2000 caracteres. Chega a corretora so quando marcado para ela.',
    'Decisao da analise':
      'Aprovar e recusar pedem a alcada da analise; cancelar, a de abrir. A decisao so registra quem, o que e quando: nao muda limite, cadastro nem bloqueio do tomador.',
    'Motivo padronizado da recusa':
      'Motivo da esteira do assunto (Cadastro, Credito ou PEP), cadastrado em Configuracoes. Sem motivo, a justificativa escrita e obrigatoria.',
    'Justificativa da decisao':
      'Por que a analise foi decidida assim, com ate 2000 caracteres. Na recusa sem motivo padronizado, e obrigatoria.',
  },
};
